module.exports = __webpack_public_path__ + "img/36.184401bd.jpg";